import React, { useEffect, useState } from 'react';
import Modal from '../../BaseComponents/Modal';
import Loader from '../../BaseComponents/Loader';
import { getTeamById, Team } from '../../../api/teams';
import './TeamViewModal.scss';
import { toast } from 'react-toastify';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  team: Team | null;
};

const TeamViewModal: React.FC<Props> = ({
  isOpen,
  onClose,
  team,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [teamDetails, setTeamDetails] = useState<Team | null>(team);

  useEffect(() => {
    if (!isOpen || !team?.id) return;

    const fetchTeamDetails = async () => {
      setIsLoading(true);
      try {
        const data = await getTeamById(team.id);
        setTeamDetails(data);
      } catch (error: any) {
        toast.error(error?.message || 'Failed to load team details');
        setTeamDetails(team);
      } finally {
        setIsLoading(false);
      }
    };

    fetchTeamDetails();
  }, [isOpen, team]);

  if (!team) return null;

  return (
    <Modal isOpen={isOpen} onClose={onClose} title='View Team' width='520px'>
      <div className='team-view-modal'>
        {isLoading ? (
          <Loader />
        ) : (
          <>
            <div className='main-info-container'>
              <h3 className='block-title'>Team details</h3>
              <div className='info-item'>
                <label className='info-label'>Name</label>
                <div className='info-value'>{teamDetails?.name || '-'}</div>
              </div>
              <div className='info-item'>
                <label className='info-label'>Description</label>
                <div className='info-value'>{teamDetails?.description || '-'}</div>
              </div>
            </div>
          </>
        )}
      </div>
    </Modal>
  );
};

export default TeamViewModal;
